import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { alert } from "../redux/slices/alertSlice";
import { deleteAccessToken } from "../redux/slices/memberSlice";
import {
  consumeSessionExpiredFlag,
  getSessionExpiryMs,
  getStoredAuthToken,
  isSessionExpired,
  markSessionExpired,
} from "../utils/session";

// setTimeout is 32-bit; longer waits are re-checked at the cap.
const MAX_TIMEOUT_MS = 2147483647;

// App-level watcher that signs the user out the moment the login session
// (expiry_timestamp from verify-otp / the token's exp claim) lapses, instead
// of waiting for the next API call to come back 401. Re-checks whenever the
// tab regains focus because timers don't fire while mobile browsers keep the
// page suspended in the background.
function useSessionExpiry() {
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.memberDetails);

  // A previous page load signed the user out on expiry and hard-redirected
  // here: tell them why.
  useEffect(() => {
    if (consumeSessionExpiredFlag()) {
      // dispatch(
      //   alert({
      //     message: "Your session has expired. Please log in again.",
      //     type: "error",
      //   })
      // );
    }
  }, [dispatch]);

  useEffect(() => {
    let timerID;

    const scheduleCheck = () => {
      clearTimeout(timerID);

      if (!getStoredAuthToken()) {
        return;
      }

      if (isSessionExpired()) {
        markSessionExpired();
        dispatch(deleteAccessToken());
        return;
      }

      const expiryMs = getSessionExpiryMs();

      if (!expiryMs) {
        return;
      }

      timerID = setTimeout(
        scheduleCheck,
        Math.min(expiryMs - Date.now(), MAX_TIMEOUT_MS)
      );
    };

    const checkOnVisible = () => {
      if (document.visibilityState === "visible") {
        scheduleCheck();
      }
    };

    scheduleCheck();

    document.addEventListener("visibilitychange", checkOnVisible);
    window.addEventListener("focus", scheduleCheck);

    return () => {
      clearTimeout(timerID);
      document.removeEventListener("visibilitychange", checkOnVisible);
      window.removeEventListener("focus", scheduleCheck);
    };
  }, [authToken, dispatch]);
}

export default useSessionExpiry;
